/**
 * Error Boundary Component
 * Catches React errors and displays fallback UI
 */

import { Component } from 'react'
import { captureException } from '../utils/monitoring'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    captureException(error, { componentStack: errorInfo?.componentStack, boundary: true })
  }

  handleGoHome = () => {
    window.location.href = '/'
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-stadium-black flex items-center justify-center px-4">
          <div className="text-center max-w-2xl">
            <h1 className="text-6xl font-black text-pitch-green mb-4">Oops!</h1>
            <h2 className="text-2xl text-white mb-4">Something went wrong</h2>
            <p className="text-gray-400 mb-8">
              We're sorry, but something unexpected happened. Please try again later.
            </p>
            <div className="flex gap-4 justify-center">
              <button
                onClick={this.handleGoHome}
                className="bg-pitch-green text-stadium-black px-6 py-3 rounded-full font-bold hover:bg-neon-green transition-all"
              >
                Go Home
              </button>
              <button
                onClick={() => window.location.reload()}
                className="border-2 border-pitch-green text-pitch-green px-6 py-3 rounded-full font-bold hover:bg-pitch-green hover:text-stadium-black transition-all"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
